import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import {DOCUMENT, IS_IOS, WINDOW} from "../../constants/environment";
import BodyControl from "../body";

export default class ModalWindow extends Component {
  static propTypes = {
    open: PropTypes.bool,
    type: PropTypes.string,
    children: PropTypes.object,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
  };
  static defaultProps = {
    open: false,
    type: 'Dark',
    children: null,
    onOpen: null,
    onClose: null,
  };

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      open: this.props.open,
      height: 0,
      //width: 0,
      type: this.props.type,
      buttonType: null,
    };

    // EPIServerのプレビュー時のモーダルの位置調整
    this.wrapperScrollTop = 0;

  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  //
  open(type, buttonType) {
    if (this.state.open === false) {

      // EPIServerのプレビュー時のモーダルの位置調整
      let isEpiServerPreview = false;
      if (WINDOW && WINDOW.epi && WINDOW.parent) {
        const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          const wrapperHeight = wrapperElement.clientHeight;
          this.wrapperScrollTop = wrapperElement.scrollTop;
          const iframe = wrapperElement.querySelector('iframe');
          if (iframe) {
            DOCUMENT.body.style.position = 'absolute';
            DOCUMENT.body.style.top = -this.wrapperScrollTop + 'px';
            const headerElement = WINDOW.document.querySelector('header') || null;
            if (headerElement) {
              headerElement.style.zIndex = 0;
            }
            iframe.style.height = wrapperHeight + 'px';
            isEpiServerPreview = true;
          }
          if (type === 'Dark' || type === 'Light') {
            this.setState({
              open: true,
              height: wrapperHeight,
              type: type,
              buttonType: buttonType,
            });
          } else {
            this.setState({
              open: true,
              height: wrapperHeight,
              type: null,
              buttonType: null,
            });
          }
        }
      }
      if (!isEpiServerPreview) {
        if (type === 'Dark' || type === 'Light') {
          this.setState({
            open: true,
            height: window.innerHeight,
            type: type,
            buttonType: buttonType,
          });
        } else {
          this.setState({
            open: true,
            height: window.innerHeight,
            type: null,
            buttonType: null,
          });
        }
        // // BODYのスクロール無効化
        // BodyControl.openModal();
      }

      // BODYのスクロール無効化
      BodyControl.openModal();

      if (this.props.onOpen !== null) this.props.onOpen();
    }
  }

  //
  close() {
    if (this.state.open === true) {

      // EPIServerのプレビュー時のモーダルの位置調整
      if (WINDOW && WINDOW.epi && WINDOW.parent) {
        const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          const iframe = wrapperElement.querySelector('iframe');
          if (iframe) {
            DOCUMENT.body.style.position = 'static';
            DOCUMENT.body.style.top = 'auto';
            const headerElement = WINDOW.document.querySelector('header') || null;
            if (headerElement) {
              headerElement.style.zIndex = 3000;
            }
            iframe.style.height = DOCUMENT.body.clientHeight + 'px';
            wrapperElement.scrollTop = this.wrapperScrollTop;
          }
        }
      }

      this.setState({
        open: false,
        height: 0,
        //width: 0
      });
      // BODYのスクロール無効化を解除
      BodyControl.closeModal();
      if (this.props.onClose !== null) this.props.onClose();
    }
  }

  //
  setType(type, buttonType) {
    if (type === 'Dark' || type === 'Light') {
      this.setState({
        type: type,
        buttonType: buttonType,
      });
    }
  }

  //
  render() {
    const {
      children,
    } = this.props;
    //
    let typeClass = '';
    if (this.state.type === 'Dark') {
      typeClass = ' dark';
    } else if (this.state.type === 'Light') {
      typeClass = ' light';
    }
    //
    let buttonTypeClass = '';
    if (this.state.buttonType === 'Dark') {
      buttonTypeClass = ' dark';
    } else if (this.state.buttonType === 'Light') {
      buttonTypeClass = ' light';
    }
    //
    return (
      <div className={'ModalWindow' + ((this.state.open === true) ? ' open': '') + typeClass}
           style={{
             height: this.state.height,
             //width: this.state.width
           }}
      >
        <div className="ModalWindow__container">
          {(children !== null) ? children: null}
          <a className={'ModalWindow__link-close' + buttonTypeClass}
             href="javascript:void(0);"
             onClick={this.handleClick}
          >
            {'CLOSE'}
          </a>
        </div>
      </div>
    );
  }

  //
  handleResize = () => {
    if (this.state.open === false) return;
    //
    this.setState({
      height: window.parent.innerHeight,
      //width: window.innerWidth
    });
  };

  //
  handleClick = (e) => {
    e.preventDefault();
    //
    this.close();
  };

  //
  onTouchMove = (e)=> {
    e.preventDefault();
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-window/index.jsx